import { render, staticRenderFns } from "./person-info.vue?vue&type=template&id=6c431822&scoped=true&"
import script from "./person-info.vue?vue&type=script&lang=js&"
export * from "./person-info.vue?vue&type=script&lang=js&"
import style0 from "./person-info.vue?vue&type=style&index=0&id=6c431822&prod&lang=scss&scoped=true&"
import style1 from "./person-info.vue?vue&type=style&index=1&id=6c431822&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c431822",
  null
  
)

export default component.exports